import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("bc_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function getToken() {
  return localStorage.getItem("bc_token");
}

export function mediaUrl(path) {
  if (!path) return null;
  const token = getToken();
  return `${API}/media/${path}?auth=${token}`;
}

// Small preview (WEBP, keeps transparency) for grids; the original stays for copy/download
export function thumbUrl(path) {
  if (!path) return null;
  const token = getToken();
  return `${API}/media/t/${path}?auth=${token}`;
}

export function assetUrl(path) {
  if (!path) return null;
  const token = getToken();
  return `${API}/assets/${path}?auth=${token}`;
}

export async function fetchBlobUrl(url) {
  const token = getToken();
  const res = await fetch(url, { headers: token ? { Authorization: `Bearer ${token}` } : {} });
  if (!res.ok) throw new Error("fetch-failed");
  const blob = await res.blob();
  return URL.createObjectURL(blob);
}

export function apiError(e) {
  const detail = e?.response?.data?.detail;
  if (detail == null) return e?.message || "Algo deu errado. Tente novamente.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((x) => (x && typeof x.msg === "string" ? x.msg : JSON.stringify(x))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
